import styled from 'styled-components';

const StyledContainer = styled.label`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}
`;

export { StyledContainer as ContentInputFlagContainer };
